module.exports = __webpack_public_path__ + "img/button-like.0258a2e4.svg";